import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AemService {
  private contentSource = new BehaviorSubject<any>({});
  currentContent = this.contentSource.asObservable();

  constructor(private apiService: ApiService) {}

  setContent(key: string, content: any) {
    const currentContent = this.contentSource.getValue();
    this.contentSource.next({
      ...currentContent,
      [key]: content
    });
  }

  getContent(key: string): Observable<any> {
    return this.currentContent.pipe(
      map(content => content[key] || {})
    );
  }

  getDashboardContent(): Observable<any> {
    return this.getContent('dashboard');
  }

  getRedeemContent(): Observable<any> {
    return this.getContent('redeem-points');
  }

  getVehicleContent(): Observable<any> {
    return this.getContent('vehicle-information');
  }

  getCardBannerContent(): Observable<any> {
    return this.getContent('card-banner');
  }

  fetchContent(pageName: string): Observable<any> {
    const pageKey = pageName.toLowerCase();
    return this.apiService.getAemPage(pageName).pipe(
      tap(data => {
        this.setContent(pageKey, data);
      })
    );
  }
}
